import { render } from "./ProgramListView.vue?vue&type=template&id=2e5a4e12&scoped=true&ts=true"
import script from "./ProgramListView.vue?vue&type=script&lang=ts"
export * from "./ProgramListView.vue?vue&type=script&lang=ts"

import "./ProgramListView.vue?vue&type=style&index=0&id=2e5a4e12&scoped=true&lang=css"

import exportComponent from "D:\\Ventla Code\\New Admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e5a4e12"]])

export default __exports__